import TableRow from "components/rows/tableRow";
import "./detailLoad.scss";

type IProps = {
  rowTitle: string;
  isData?: boolean;
};

export default function BaseInfLoaing({ rowTitle, isData = false }: IProps) {
  return (
    <>
      <table className="detail-load">
        <tbody>
          <TableRow title={rowTitle}>
            <div>{isData ? "검색된 데이터가 없습니다." : ""}</div>
          </TableRow>
        </tbody>
      </table>
    </>
  );
}
